import * as React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./Settlements.WithdrawalBatches.List";
import Summary from "./Settlements.WithdrawalBatches.Summary";

const batches = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/settlements/withdrawals/batches"
      render={() => <List {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/settlements/withdrawals/batches/:id/summary"
      render={routerProps => <Summary {...{ ...props, ...routerProps }} />}
    />
  </Switch>
);

export default batches;
